// test639
(639 && 0);
